import script from "./CommentArea.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentArea.vue?vue&type=script&setup=true&lang=js"

import "./CommentArea.vue?vue&type=style&index=0&id=1df011f7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df011f7"]])

export default __exports__